import React from 'react';
import { Stack, Typography, useTheme, Box } from '@mui/material';

export interface Props {
	items: { label: string; values: string[] | undefined; variant?: string }[];
}
const DetailSection = (props: Props) => {
	const theme = useTheme();
	const { items } = props;

	const variantColors = {
		neutral: theme.palette.colors.tundra.main,
		warning: theme.palette.warning.main,
		success: theme.palette.success.dark,
		danger: theme.palette.error.dark,
		noVariant: theme.palette.common.black,
	};

	return (
		<Box data-sl="mask">
			{items.map((item) => {
				return (
					<Stack sx={{ width: { sm: '25%' } }} spacing={4} direction="column">
						<Stack direction={{ xs: 'column', sm: 'row' }}>
							<Box sx={{ minWidth: '75%', mb: { xs: 1, sm: 3 } }}>
								<Typography variant="body2" color="secondary">
									{item.label}
								</Typography>
							</Box>
							<Stack sx={{ minWidth: '100%' }} direction="column">
								{item.values?.map((value) => (
									<Typography
										sx={{ color: variantColors[item.variant ?? 'noVariant'], mb: 1 }}
										variant="body1"
									>
										{value}
									</Typography>
								))}
							</Stack>
						</Stack>
					</Stack>
				);
			})}
		</Box>
	);
};

export default DetailSection;
